import { useState } from "react";
import { QuestionProps } from "../typings/register";
import Tag from './Tag'
import { setQuestionAnswers } from '../services/memberService'
import { AnswerdQuestionsProps } from "../typings/member";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { useHistory } from "react-router";
import { COMPLETED_PROFILE_PAGE, HOMEPAGE } from "../navigation/Constants";
import EditTagQuestion from "./EditTagQuestion";
import EditTagsQuestion from "./EditTagsQuestion";
import { useLocation } from "react-router-dom";

export interface QuestionTagProps {
    question: QuestionProps;
    next: () => void;
    hasNext: () => boolean;
}

const QuestionTag = (props: any) => {
    let history = useHistory();
    const location = useLocation();

    const { question, next, hasNext }: QuestionTagProps = props;
    const [selectedTag, setSelectedTag] = useState<number>(-1);
    const member = useSelector((state: RootState) => state.member);

    const max_Answers = question.maxAnswer;
    const minAnswers = question.minAnswer;

    const onSave = async (tags: number[]) => {
        const sentData: AnswerdQuestionsProps = { questionId: question.questionId, tags }
        const { data } = await setQuestionAnswers(member.memberCode, sentData);
        if (hasNext()) next();
        else history.push(COMPLETED_PROFILE_PAGE);
        //history.push(HOMEPAGE)
    };

    const enabled = selectedTag !== -1;

    return (
        <>
            {
                question && question.tags ?
                    max_Answers === 1 ?
                        <EditTagQuestion
                            title={question.question}
                            subtitle={question.questionSubTitle}
                            buttonText={"שמור"}
                            tags={question.tags}
                            onSave={onSave}
                            skipButtonLink={question.skipButtonLink}
                        />

                        : <EditTagsQuestion
                            title={question.question}
                            questionMaxAsnwer={max_Answers}
                            questionMinAsnwer={minAnswers}
                            subtitle={question.questionSubTitle}
                            buttonText={"שמור"}
                            tags={question.tags}
                            onSave={onSave}
                            selectedTagsValue={undefined}
                            skipButtonLink={question.skipButtonLink}
                        />
                    : null

            }
        </>
    )
}

export default QuestionTag;